import React from 'react';
import PropTypes from 'prop-types';
import { Link, NavLink, useHistory } from "react-router-dom";
import clsx from "clsx";
import { Dropdown, ScrollLink } from "presentation/common";
import { DownArrowIcon } from "presentation/common/components/style-guide/icons";
import { AppRoutes } from "application/index";
import { useSignDocuments } from "application/use-sign-documents";

import styles from './HeaderActions.module.scss';

const NotAuthenticatedActions = React.memo(({ useInsideScroll }) => {
  return useInsideScroll
    ? <>
      <li className="hover:opacity-80">
        <ScrollLink className="mr-3" to="benefit-section"> Beneficios </ScrollLink>
      </li>
      <li className="hover:opacity-80">
        <ScrollLink className="mr-3" to="question-section"> Preguntas Frecuentes </ScrollLink>
      </li>
      <li className="hover:opacity-80">
        <Link to={AppRoutes.signIn}> Iniciar Sesión </Link>
      </li>
    </>
    : <>
      <li className="hover:opacity-80">
        <Link className="mr-3" to="/"> Beneficios </Link>
      </li>
      <li className="hover:opacity-80">
        <Link className="mr-3" to="/"> Preguntas Frecuentes </Link>
      </li>
      <li className="hover:opacity-80">
        <Link to={AppRoutes.signIn}> Iniciar Sesión </Link>
      </li>
    </>
});

export const HeaderActions = ({ isAuthenticated, userInfo, onSignOut, useInsideScroll, className }) => {
  const { docs = [] } = useSignDocuments();
  const history = useHistory();

  return (
    <ul className={clsx(styles.options, className)}>
      {
        isAuthenticated
          ? <>
            <li className={styles.navItem}>
              <NavLink
                activeStyle={{ color: "var(--primary)" }}
                to={AppRoutes.myDocs} exact>
                Mis Inscripciones
              </NavLink>
            </li>
            <li className={clsx(styles.badgeContainer, styles.navItem)}>
              <NavLink
                exact
                activeStyle={{ color: "var(--primary)" }}
                to={AppRoutes.signDocuments}>Por Firmar</NavLink>
              {
                docs?.length > 0 &&
                <span className={styles.badge}>{docs.length}</span>
              }
            </li>
            <li>
              <Dropdown items={[
                { id: 'profile', label: 'Mi Perfil' },
                { id: 'logout', label: 'Cerrar Sesión' }]}
                onSelectItem={(item, index) => {
                  if (item.id === 'profile') {
                    history.push(AppRoutes.myProfile)
                    return;
                  }

                  onSignOut();
                }}>
                <span>{userInfo?.fullName}</span>
                <DownArrowIcon fontSize='small' />
              </Dropdown>
            </li>
          </>
          :
          <div className="hidden md:block">
            <NotAuthenticatedActions useInsideScroll={useInsideScroll} />
          </div>
      }
    </ul>
  );
};

HeaderActions.propTypes = {
  isAuthenticated: PropTypes.bool,
  onSignOut: PropTypes.func,
  userInfo: PropTypes.any,
  useInsideScroll: PropTypes.bool
};

HeaderActions.defaultProps = {
  isAuthenticated: false,
  onSignOut: PropTypes.func,
  userInfo: {},
  useInsideScroll: false
};

export default React.memo(HeaderActions);
